import React from 'react';

export default function StatusIcon({
  width = 48,
  height = 48,
  fill = '#9F9FA0',
  className,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  width?: number | string;
  height?: number | string;
  fill?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_10015_20237)">
        <path
          d="M0.00027608 16.6942C0.200699 16.1908 0.56146 15.8928 0.936 15.5209L18.6133 0.385715C19.4726 -0.187785 20.2906 -0.118915 21.0484 0.576047L38.871 15.8477C40.17 17.1287 39.1241 19.1685 37.2939 18.8291C36.749 18.7277 36.273 18.1141 35.8196 17.8199C35.5102 18.908 33.987 19.181 33.1602 18.461C32.1857 17.612 32.6842 16.033 32.4888 14.9148L19.7206 4.05462L6.84471 15.0538V32.5343H17.2993C17.5398 32.5343 18.1799 32.8711 18.3678 33.0602C19.3536 34.0532 18.8125 35.6886 17.4809 35.9966L4.83673 35.9941C4.14777 35.9365 3.37489 35.0237 3.37489 34.3625V18.0065C2.28134 19.2223 0.71303 19.191 -0.000976562 17.6321V16.6942H0.00027608Z"
          fill={fill}
        />
        <path
          d="M35.537 48H33.0994C22.7701 46.9769 16.9528 35.2552 22.9905 26.5062C28.6324 18.3307 40.763 18.6726 45.984 27.106C51.2877 35.6735 45.5456 47.2236 35.537 48ZM44.5711 34.2848C44.5711 28.6099 39.9689 24.0094 34.2919 24.0094C28.6149 24.0094 24.0127 28.6099 24.0127 34.2848C24.0127 39.9597 28.6149 44.5602 34.2919 44.5602C39.9689 44.5602 44.5711 39.9597 44.5711 34.2848Z"
          fill={fill}
        />
        <path
          d="M32.1819 40.5696C31.6332 40.5696 31.1084 40.3517 30.7201 39.9648L27.9605 37.205C27.1538 36.3986 27.1538 35.09 27.9605 34.2836C28.7672 33.4772 30.0762 33.4772 30.8829 34.2836L32.1819 35.5821L37.6635 30.1038C38.4702 29.2974 39.7792 29.2974 40.5859 30.1038C41.3926 30.9102 41.3926 32.2188 40.5859 33.0252L33.6437 39.9648C33.2567 40.3517 32.7306 40.5696 32.1819 40.5696Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_10015_20237">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
